import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import UserCompanyName from '@/components/user-companies/UserCompanyName.vue';
import UserCompanyTableActions from '@/components/user-companies/UserCompanyTableActions.vue';
import type { UserCompany } from '@/types';
import type { CellContext, ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<UserCompany>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.name',
            }),
        cell: ({ row }) => {
            return h(UserCompanyName, {
                userCompany: row.original,
            });
        },
    },
    {
        id: 'employee_users',
        accessorFn: (row) => row.employee_users.map((user) => user.name).join(', '),
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.employees',
            }),

        cell: (ctx: CellContext<UserCompany, any>) => {
            return h(DataTableTruncate, {
                value: ctx.getValue(),
            });
        },
    },
    {
        id: 'employee_users_count',
        accessorFn: (row) => row.employee_users.length,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.count',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'has_salary',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.has_salary',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_salary,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        id: 'actions',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(UserCompanyTableActions, {
                userCompany: row.original,
            });
        },
    },
];
